(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  if (!customElements.get('countdown-timer')) {
    class CountdownTimer extends HTMLElement {
      constructor() {
        super();
        this.endDate = new Date(this.dataset.endDate.replace(' ', 'T')).getTime();
        this.daysContainer = this.querySelector('[data-days-container]');
        this.daysEl = this.querySelector('[data-days]');
        this.hoursEl = this.querySelector('[data-hours]');
        this.minutesEl = this.querySelector('[data-minutes]');
        this.secondsEl = this.querySelector('[data-seconds]');
        this.timer = null;
      }

      connectedCallback() {
        if (isNaN(this.endDate) || !this.hoursEl || !this.minutesEl || !this.secondsEl) {
          this.style.display = 'none';
          return;
        }

        this.update();
        this.timer = setInterval(() => this.update(), 1000);
      }

      disconnectedCallback() {
        if (this.timer) {
          clearInterval(this.timer);
        }
      }

      update() {
        const now = new Date().getTime();
        const distance = this.endDate - now;

        if (distance < 0) {
          clearInterval(this.timer);
          this.style.display = 'none';
          return;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        if (this.daysEl) {
            if (days > 0) {
                this.daysEl.textContent = days;
                if (this.daysContainer) this.daysContainer.style.display = 'inline-flex';
            } else {
                if (this.daysContainer) this.daysContainer.style.display = 'none';
            }
        }
        
        this.hoursEl.textContent = String(hours).padStart(2, '0');
        this.minutesEl.textContent = String(minutes).padStart(2, '0');
        this.secondsEl.textContent = String(seconds).padStart(2, '0');
      }
    }
    customElements.define('countdown-timer', CountdownTimer);
  }

  } catch(e) { console.error(e); }
})();
})();
